import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '../../shared/ui/ConfirmDialog.js';

export interface BuyAgainTrimDialogProps {
  removedCount: number;
  onConfirm: () => void;
  onCancel: () => void;
  pending?: boolean;
  /**
   * All lines unavailable / empty cart after trim — show empty-trim copy and
   * disable confirm so start is never called with an empty cart.
   */
  canContinue?: boolean;
}

/**
 * Buy-again trim confirm — ConfirmDialog owns OverlayBackDismiss (cancel).
 */
export function BuyAgainTrimDialog({
  removedCount,
  onConfirm,
  onCancel,
  pending = false,
  canContinue = true,
}: BuyAgainTrimDialogProps): JSX.Element {
  const { t } = useTranslation('customer');
  const emptyTrim = !canContinue;

  return (
    <ConfirmDialog
      open
      title={
        emptyTrim
          ? t('orders.buyAgain.trimAllUnavailableTitle')
          : t('orders.buyAgain.trimTitle')
      }
      description={
        emptyTrim
          ? t('orders.buyAgain.trimAllUnavailableBody')
          : t('orders.buyAgain.trimBody', { count: removedCount })
      }
      confirmLabel={t('orders.buyAgain.continueTrimmed')}
      cancelLabel={t('qrPayment.cancel')}
      onConfirm={onConfirm}
      onCancel={onCancel}
      pending={pending}
      confirmDisabled={emptyTrim}
      testId="buy-again-trim-dialog"
    />
  );
}
